import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageShell, Section, SectionLabel, Heading, Card, CardHeader, RowList, Row } from '../../components/elevation';
import { OBJECT_TYPES } from '../../lib/method/content';

export default function ObjectTypesPage() {
  return (
    <PageShell>
      <Section>
        <Link
          to="/elevation/method"
          className="inline-flex items-center gap-1 text-sm text-charcoal-500 hover:text-charcoal-700 dark:text-charcoal-400 dark:hover:text-charcoal-200 mb-4"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> The Method
        </Link>
        <SectionLabel>The Method</SectionLabel>
        <Heading as="h1" size="xl" className="mb-4">
          Six kinds of things you can prioritize
        </Heading>
        <p className="text-charcoal-700 dark:text-charcoal-300 max-w-3xl leading-relaxed">
          <em>Managing Priorities</em> argues that almost anything worth prioritizing falls into
          one of six universal object types. What you're prioritizing changes which criteria make
          sense and how much political weight the decision carries.
        </p>
      </Section>

      <Section className="mb-0">
        <Card flush>
          <CardHeader label="OBJECT TYPES" title="The six types" count={OBJECT_TYPES.length} />
          <RowList>
            {OBJECT_TYPES.map((t) => (
              <Row key={t.name}>
                <span className="font-heading font-semibold text-charcoal-900 dark:text-charcoal-50 w-32 shrink-0">
                  {t.name}
                </span>
                <span className="text-charcoal-600 dark:text-charcoal-300">{t.examples}</span>
              </Row>
            ))}
          </RowList>
        </Card>
      </Section>
    </PageShell>
  );
}
